import { render, staticRenderFns } from "./_DeliveryCompany.vue?vue&type=template&id=3a92f806&"
import script from "./_DeliveryCompany.vue?vue&type=script&lang=js&"
export * from "./_DeliveryCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports